export const countryBandConfig = {
  uae: {
    backgroundImage: "background_border.svg",
    backgroundImageMobile: "country_bordermob.png",
    backgroundColor: "#1E4B4A",
    textColor: "#ffffff",
    height: "402px"
  }
};